import { FC, useState, useEffect } from 'react';

import { useEventContext } from '../../hooks/contexts/event.context';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import ComboLayout from '../Layout/combo';
import * as Styles from './combo-list.styles';

const ComboList: FC = () => {
  const { translate } = useI18nContext();
  const { comboList } = useEventContext();

  const [localSelectedCombo, setLocalSelectedCombo] = useState<number | null>(null);

  useEffect(() => {
    setLocalSelectedCombo(comboList[0].id);
  }, []);

  return (
    <ComboLayout
      selectedCombo={localSelectedCombo}
      curComponent="combo"
    >
      <Styles.ComboListContainer>
        <Styles.ComboListTitle>{translate(['COMBO', 'COMBO_LIST', 'TITLE'])}</Styles.ComboListTitle>
        <Styles.ListOfCombos>
          {comboList.map((combo) => (
            <Styles.ComboListItem
              key={combo.id}
              $selected={combo.id === localSelectedCombo}
            >
              <label
                htmlFor={`selection-combo-${combo.id}`}
              >
                <input
                  onChange={() => setLocalSelectedCombo(combo.id)}
                  type="radio"
                  name="selection-combo"
                  id={`selection-combo-${combo.id}`}
                  checked={combo.id === localSelectedCombo}
                />
                {combo.name}
              </label>
            </Styles.ComboListItem>
          ))}
        </Styles.ListOfCombos>
      </Styles.ComboListContainer>
    </ComboLayout>
  );
};

export default ComboList;
